import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { UnifiedThemeProvider } from '@backstage/theme';
import { slalomLightTheme, slalomDarkTheme } from '../styles/theme';
import LightIcon from '@material-ui/icons/WbSunny';
import DarkIcon from '@material-ui/icons/Brightness2';

// Injects --bui-bg-app CSS token override without depending on @mui/material.
// @backstage/ui defines this token in a static stylesheet disconnected from
// the MUI palette, so it must be overridden via a global style injection.
const BuiBgAppOverride = () => (
  <style>{`:root { --bui-bg-app: #EEEEEE; }`}</style>
);

const slalomLightThemeExtension = ThemeBlueprint.make({
  name: 'slalom-light',
  params: {
    theme: {
      id: 'slalom-light',
      title: 'Slalom Light',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={slalomLightTheme}>
          <BuiBgAppOverride />
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

const slalomDarkThemeExtension = ThemeBlueprint.make({
  name: 'slalom-dark',
  params: {
    theme: {
      id: 'slalom-dark',
      title: 'Slalom Dark',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={slalomDarkTheme}>
          <BuiBgAppOverride />
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [slalomLightThemeExtension, slalomDarkThemeExtension],
});
